import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddEditCodeGroupComponent } from '../pop-ups/add-edit-code-group/add-edit-code-group.component';
import { Button, CurrentTab, FooterTitle, Path, PopUpTitles, StatusChange, TabNames, Url } from '../../../../../app/shared/model/enum';
import { AgGridI, PaginationBaseModel } from '../../../../../app/shared/components/ag-grid/ag-grid.model';
import { AgGridService } from '../../../../../app/shared/components/ag-grid/ag-grid.service';
import { AgGridDataModelCodeCrosswalk, AgGridDataModelVendorContacts } from '../../../../../app/components/crm/crm.model';
import { CodeCrosswalkService } from '../code-crosswalk.service';
import { ToastrService } from 'ngx-toastr';
import { Id } from './code-crosswalk.model';
import { CommonModelPopUpComponent } from '../../../../../app/shared/components/common-model-pop-up/common-model-pop-up.component';
import { DockService } from '../../../../../app/shared/components/footer/dock.service';
import { StorageService } from '../../../../../app/shared/services/storage.service';
import { CrmService } from '../../../../../app/components/crm/crm.service';
import { Menu } from '../../../../../app/shared/services/nav.service';
import { TabsService } from '../../../../../app/shared/components/tabs/tabs.service';
import { Router } from '@angular/router';
import { ImportCodeCrosswalkComponent } from '../pop-ups/import-code-crosswalk/import-code-crosswalk.component';
import { AgGridComponent } from '../../../../../app/shared/components/ag-grid/ag-grid.component';
import { GridName, StorageName } from '../../../../shared/model/ag-grid-common-constant';
import { SendDataService } from '../../../../shared/services/send-data.service';
import { RealtimeService } from '../../../../shared/services/realtime.service';
import { RealTimeUpdateService } from '../../../../shared/services/realtime-update-service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-code-crosswalk',
  templateUrl: './code-crosswalk.component.html',
  styleUrls: ['./code-crosswalk.component.scss']
})
export class CodeCrosswalkComponent implements OnInit {
  paginationBaseModel    = new PaginationBaseModel();
  pinned                 :boolean=false;
  idList                 :any;
 @ViewChild(AgGridComponent) agGridComponent: AgGridComponent;
  @Input() footerIcon    : string;
  enumPopUpTitles        = PopUpTitles;
  tabName = TabNames;
  sicName: string[] = [];
  selectedData: any[] = [];
  tabNames = CurrentTab;
  enumButtonName = Button;
  storageName = StorageName;
  totalRecords : number;
  gridApiForCodeCrossWalkList : any;
  dataUpdateSubscription: Subscription;
  constructor(public modalService             : NgbModal,
              private agGridService           :AgGridService,
              public codeCrosswalkService     :CodeCrosswalkService,
              public toaster                  : ToastrService,
              private dockService             : DockService,
              public crmService               : CrmService,
              public storageService                  : StorageService,
              public tabsService              : TabsService,
              private router                  : Router,
              public sendDataService: SendDataService,
               public realtimeService: RealtimeService,
                  public realTimeUpdateService: RealTimeUpdateService,
          
    ) { }

  enumUrl     = Url;
  footerTitle = FooterTitle
  enumPath    = Path;
  agGridCodeCrosswalks: AgGridI;
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>

  ngOnInit(): void {
    this.agGridCodeCrosswalks = AgGridDataModelCodeCrosswalk;
    this.pinned = this.dockService?.pinnedlist?.find((a) => a?.path == this.enumPath.CROSSWALK) ?.pinned ?? false;
    if (!this.pinned) {
     this.getPinnedValue()
    }

    this.codeCrosswalkService.openAddModal.subscribe((res)=>{
      if(res==true){
        this. addEditCodeGroupPopup()
      }
    });

    this.codeCrosswalkService.valuePass.subscribe((res) => {
      if (res == true) {
        this.getAllCodeCrossWalks();
      }
    });
   this.subscribeToRealTimeUpdates();
  }

  subscribeToRealTimeUpdates(): void {
    this.dataUpdateSubscription = this.realtimeService?.liveDataUpdates$.subscribe(liveData => {
        if (liveData) {
          if (liveData.StatusChange === StatusChange.CodeCrosswalkCreated ||
            liveData.StatusChange === StatusChange.CodeCrosswalkUpdated ||
            liveData.StatusChange === StatusChange.CodeCrosswalkDeleted) {
            this.realTimeUpdateService.subscribeToUpdates(this.gridApiForCodeCrossWalkList, liveData)
          }
        }
    });
  }
  searchRoleByText(event){
  this.paginationBaseModel.pageNumber = 1;
  this.paginationBaseModel.searchText=event;
  this.getAllCodeCrossWalks()
  this.idList = [];
  }
  onSelectionChange(params){
    this.selectedData  = params?.api?.getSelectedRows();
    this.sicName = this.selectedData.map((items) => {return items.sic; });
    this.idList =   params?.api?.getSelectedRows()?.map(a=>a.id);
  }

  addEditCodeGroupPopup(){
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size:'md',
      windowClass:'manage-manufacturer'
    };
    const modalRef = this.modalService.open(AddEditCodeGroupComponent,modalOption);
    modalRef.result.then((result) => {
      if(result){
      }
  })
  } 
  open_DeleteModal() {
    const modalOption: NgbModalOptions = {
      centered: window.innerWidth > 1025 ? false : true,
      backdrop: "static",
      keyboard: false,
      windowClass: "markAsActiveInactive",
    };
    if (this.idList.length != 0) {
      const modalRef = this.modalService.open(
        CommonModelPopUpComponent,
        modalOption
      );
      modalRef.componentInstance.title = this.enumPopUpTitles.DELETE;
      let companyName = this.sicName[1] != undefined ? ", " + this.sicName[1] : "";
      modalRef.componentInstance.fullName = `${this.sicName[0]}${companyName} ${this.sicName.length > 2? "&" + " " + (this.sicName.length - 2 + " ") + "others" : ""} `;
      modalRef.componentInstance.currentTab = this.tabNames.CODECROSSWALK_TAB;
      modalRef.componentInstance.pageType = this.tabName.CODECROSSWALKPOPUP;
      modalRef.componentInstance.delPopupforAdmin.subscribe((res) => {
        if (res){
            this.deletedCodeGroupPopup();
        }
      });
    }
  }
  
  onDeleteIconClick(params){
    this.openDeletePopup(params?.detail?.data)
  }
  openDeletePopup(params) {
    const modalOption: NgbModalOptions = {
      centered: window.innerWidth > 1025 ? false : true,
      backdrop: "static",
      keyboard: false,
      windowClass: "markAsActiveInactive",
    };
    if (params.data.id) {
      const modalRef = this.modalService.open( CommonModelPopUpComponent,modalOption);
      modalRef.componentInstance.title = this.enumPopUpTitles.DELETE;
      modalRef.componentInstance.fullName = params.data.sic;
      modalRef.componentInstance.currentTab = "code-crosswalk";
      modalRef.componentInstance.pageType = this.tabName.CODECROSSWALKPOPUP;
      modalRef.componentInstance.delPopupforAdmin.subscribe((res) => {
        if (res){
          this.idList =  [params.data.id];
          this.deletedCodeGroupPopup();
        }
      });
    }
  }
  
  deletedCodeGroupPopup(){
    if (this.idList.length > 0) {
      const idInstance = new Id(this.idList);
      this.codeCrosswalkService.deleteCodeCrosswalk(idInstance).subscribe((res) => {
        if (res.isSuccess) {
          this.toaster.success(res.message);
         this.gridApiForCodeCrossWalkList?.api?.updateRowData({ remove: this.selectedData });
         this.sendDataService.setDeletedMesage(res)
        if(this.paginationBaseModel?.pageSize == this.selectedData?.length){
          this.getAllCodeCrossWalks() 
        }else
        this.grids.first.updatePaginationData(this.paginationBaseModel,this.totalRecords -  this.selectedData?.length);
        } else {
          this.toaster.error(res.message);
        }
      });
      }

  }
  onEditIconClick(params){
    const copyOfObject = Object.assign({}, params?.detail?.data?.data);
    const modalRef = this.modalService.open(AddEditCodeGroupComponent, {
       centered: true,
       backdrop: "static",
       size:'md',
       windowClass: "manage-manufacturer",
     });
      modalRef.componentInstance.insertUpdateCodeCrosswalk =  copyOfObject;
 
  }
  openFavouriteDockPopup(pinned) {
    if (!pinned) {
      const modalOption: NgbModalOptions = {
        centered:  window.innerWidth > 1025 ? false : true,
        backdrop: "static",
        keyboard: false,
        windowClass: "markAsActiveInactive",
      };
      const modalRef = this.modalService.open(CommonModelPopUpComponent, modalOption );
      modalRef.componentInstance.title = this.enumPopUpTitles.FAVOURITE_DOCKS;
      modalRef.result.then((result) => {
        if (result.confirm) {
          this.pinActive(pinned);
        }
        if (!result.confirm) {
          this.pinned = !this.pinned;
        }
        });
       }
       else if (pinned) {
      this.pinActive(pinned);
    }
  }
    //#region pinned functionality
    pinActive(pinned) {
      if (pinned) {
        this.dockService.addFavouriteDocks(this.enumUrl.CROSSWALK, pinned,this.footerTitle.CROSSWALK);
      }
      if (!pinned) {
        this.dockService.removeFavouriteDocks();
      }
    }
  
    //#region filter code start
    getPinnedValue() {
      this.crmService.getUserSetting() .subscribe(res => {
          if (res?.isSuccess) {
              let json = JSON.parse(res?.response) ?? {}
              this.pinned =  json.pinnedValues?.find((a) => a?.path == this.enumPath.CROSSWALK)  ?.pinned ?? false;
            if (json.pinnedValues && !this.dockService.pinnedlist) {
               this.storageService.store('pinnedValues', json.pinnedValues);
               this.dockService.pinnedlist = json.pinnedValues
            }
          }
        })
    }
    openImport(){
      const modalOption: NgbModalOptions = {
        centered: true,
        backdrop: "static",
        keyboard: false,
        windowClass: "codeCrosswalk",
      };
      const modalRef = this.modalService.open(ImportCodeCrosswalkComponent,modalOption);
     
      modalRef.result.then((result) => {
        this.codeCrosswalkService.valuePopup.next(false)
        if(result){
          this.getAllCodeCrossWalks()
        }
        });

    }
    navigateToimportCodecrosswalk(buttonImport){
      if(buttonImport === 'Import Codecrosswalk'){
        const item : Menu = {path:  this.enumPath.IMPORT_CROSSWALK, icon: '', title: 'Import', type: 'link'}
        this.tabsService.addTab(item);
        this.router.navigateByUrl(this.enumPath.IMPORT_CROSSWALK);
        this.crmService.sendImportId.next(3)
      }
    
    }

    onGridReady(event) {
      this.gridApiForCodeCrossWalkList = event;
      this.paginationBaseModel =  this.storageService.retrieve(GridName.AG_GRID_PAGINATIONMODEL);
      if(this.paginationBaseModel)
      this.getAllCodeCrossWalks()
    }
    
    onPagination(pagination: PaginationBaseModel) {
      this.storeChangedPagination(pagination);
      this.getAllCodeCrossWalks()
    }
    storeChangedPagination(paginationModel: PaginationBaseModel){
      this.paginationBaseModel = paginationModel
    }
  
    getAllCodeCrossWalks() {
      if (this.grids?.first){ 
        this.grids.first.agGridPaginationConfig.rows = []
        this.grids.first.isLoading = true;
      this.agGridService.getAllCodeCrosswalk(this.paginationBaseModel).subscribe({
       next : (res) =>{
        if(res.isSuccess){
          this.grids.first.isLoading = false;
          this.gridApiForCodeCrossWalkList?.api?.setRowData(res?.response??[]);
          if(!res?.response?.length){this.grids.first.agGridPaginationConfig.rows = []}
          let codeCrossWalkData = res?.response??[];
          this.totalRecords = res.totalRecords
          this.storageService.store(StorageName.ADMIN_CODE_CROSSWALK, codeCrossWalkData);
          this.grids.first.updatePaginationData(this.paginationBaseModel,res.totalRecords);
        } else {
          this.grids.first.isLoading = false;
          this.grids.first.agGridPaginationConfig.rows = []
          this.gridApiForCodeCrossWalkList?.api?.setRowData([]);
        }
       },
       error : (err) => {
        this.grids.first.isLoading = false;
        this.grids.first.agGridPaginationConfig.rows = []
        this.gridApiForCodeCrossWalkList?.api?.setRowData([]);
       }
      })
    }
  }
    
}
